import React, { useState, useEffect } from "react"
import { useRequest } from '@/hooks/useRequest'
import { Wrapper, A, LiteratureWrapper } from "./style"
import { LiteratureType } from '@/types/fepoPages'

export const Literature = ({
  project,
  mypageUrl,
  isGeneral,
  pimId,
  subjId,
  subjName,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [literatureData, isLoading, error] = useRequest<LiteratureType>({
    url: '/fgos_pim_struct/getSubjsLiterature',
    body: { subjId },
  }, [subjId], 1000)

  return (
    <Wrapper>
      {(project === "training" || isGeneral) && (
        <A
          className="btn btn-primary"
          href={`/sites/default/files/codificators/${
            project === "fepo" ? "fepo/" : ""
          }${subjId}.doc`}
        >
          Структура содержания
        </A>
      )}{" "}
      <A
        className={`btn btn-primary ${(!literatureData || isLoading || error) && 'disabled'}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        Список литературы
      </A>{" "}
      {isGeneral && project === "fepo" && (
        <A
          className="btn btn-primary"
          href={`${mypageUrl}/demo_test.php?oopkodes=fgos&pimid=${pimId}&subjname=${subjName}`}
          target="_blank"
        >
          Демовариант
        </A>
      )}
      {literatureData && isOpen && <LiteratureWrapper dangerouslySetInnerHTML={{ __html: literatureData![0].content }} />}
    </Wrapper>
  )
}
